/**
 * Shared Tailwind input field class. Used by all forms in the app.
 * Centralized so design-token changes happen in one place.
 *
 * Contrast (WCAG 1.4.11, 3:1 for a control's boundary): the border is
 * neutral-500 at 85% (it blends over the white field to #888): 3.5:1 against
 * the field and at least 3.06:1 against every SectionCard wash (indigo is the
 * tightest). neutral-200/300/400 are all under 3:1, so don't lighten it. The
 * focused border is sky-600 (4.1:1). Placeholders are neutral-500 (4.7:1).
 */
export const INPUT_CLASS =
  "mt-1 block w-full rounded-xl border border-neutral-500/85 bg-white px-3.5 py-2.5 text-sm text-neutral-900 shadow-sm transition placeholder:text-neutral-500 focus:border-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-500/30";

/**
 * The pre-v2 field style, kept ONLY for the landing page's beta-feedback form:
 * the v2 brief requires the landing to stay pixel-identical while the inside
 * pages are restyled. TODO(team): move the landing to INPUT_CLASS once the
 * landing is next redesigned (its borders are under the 3:1 contrast minimum).
 */
export const LANDING_INPUT_CLASS =
  "mt-1 block w-full rounded-xl border border-neutral-200 bg-white px-3.5 py-2.5 text-sm text-neutral-900 shadow-sm transition placeholder:text-neutral-400 focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-500/30";
